import React, { useState,useEffect } from 'react'
import './ControlsMenu.css';

export default function ControlsMenu() {

    const [activeSection, setActiveSection] = useState(null);
    useEffect(()=>{
        setActiveSection("createProducts")
    },[])
    return (
        <div className="controls-menu">
            <ul>
                <li onClick={() => setActiveSection("createProducts")}>New Products</li>
                <li onClick={() => setActiveSection("editProducts")}>Edit Products</li>
                <li onClick={() => setActiveSection("createCollection")}>New Collection</li>
                <li onClick={() => setActiveSection("editCollection")}>Edit Collection</li>
                <li onClick={() => setActiveSection("viewOrders")}>View Orders</li>
                <li onClick={() => setActiveSection("editOrders")}>Edit Orders</li>
                <li onClick={() => setActiveSection("viewUsers")}>View Users</li>
            </ul>

            {activeSection === "createProducts" && (
                <div className='box'>
                    <h1>Create Products</h1>

                    <label htmlFor="product-name">Product Name:</label>
                    <input type="text" id="product-name" />
                    <label htmlFor="mainimg">main image</label>
                    <input type="file" name="mainimg" id="mainimg" />
                    <label htmlFor="carouselimg">carousel images</label>
                    <input type="file" name="carouselimg" id="carouselimg" multiple />
                    <label htmlFor="product-description">Product Description:</label>
                    <textarea id="product-description" placeholder='product discription'></textarea>

                    <label htmlFor="product-price">Product Price:</label>
                    <input type="number" id="product-price" placeholder='price in Rs.' />
                    <label htmlFor="coloruser">Color for user:</label>
                    <input type="text" id='coloruser' placeholder='color for user seperated by commas' disabled/>
                    <label htmlFor="colorcomp">Color for Hex:</label>
                    <input type="text" id='colorcomp' placeholder='color in # code separated by commas' />

                    <button type="submit">Add Product</button>
                </div>
            )}

            {activeSection === "editProducts" && 
             <div className="box">

             </div>
            }
            {activeSection === "createCollection" && <h1>Create Collection</h1>}
            {activeSection === "editCollection" && <h1>Edit Collection</h1>}
            {activeSection === "viewOrders" && <h1>View Orders</h1>}
            {activeSection === "editOrders" && <h1>Edit Orders</h1>}
            {activeSection === "viewUsers" && <h1>View Users</h1>}
        </div>
        
    )
}
